<template>
  <div class="modal-overlay" @click="handleOverlayClick">
    <div class="modal-container" @click.stop>
      <div class="modal-header">
        <h3>{{ item.text || 'Навчальне відео' }}</h3>
        <div class="header-actions">
          <button 
            v-if="item.link" 
            @click="openNotionLink" 
            class="notion-button"
            :title="lang === 'en' ? '' : 'Open Documentation'"
          >
            <svg data-v-9b82fc06="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-9b82fc06="" d="M5 18H10C11.1046 18 12 18.8954 12 20V11C12 8.17157 12 6.75736 11.1213 5.87868C10.2426 5 8.82843 5 6 5H5C4.05719 5 3.58579 5 3.29289 5.29289C3 5.58579 3 6.05719 3 7V16C3 16.9428 3 17.4142 3.29289 17.7071C3.58579 18 4.05719 18 5 18Z" fill="white"></path><path data-v-9b82fc06="" d="M19 18H14C12.8954 18 12 18.8954 12 20V11C12 8.17157 12 6.75736 12.8787 5.87868C13.7574 5 15.1716 5 18 5H19C19.9428 5 20.4142 5 20.7071 5.29289C21 5.58579 21 6.05719 21 7V16C21 16.9428 21 17.4142 20.7071 17.7071C20.4142 18 19.9428 18 19 18Z" fill="white"></path></svg>
            {{ lang === 'en' ? 'Documentation' : 'Документація' }}
          </button>
          <button class="close-button" @click="$emit('close')" aria-label="Закрити">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      </div>
      
      <div class="modal-body">
        <!-- YouTube Video Section -->
        <div v-if="item && item.link" class="video-container">
          <div class="video-wrapper">
            <iframe
              ref="videoFrame"
              :src="youtubeUrl"
              width="100%"
              height="100%"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
              @load="handleVideoLoad"
              @error="handleVideoError"
            />
            
            <div v-if="isVideoLoading" class="loading-overlay">
              <div class="loading-spinner"></div>
              <p>Завантаження відео...</p>
            </div>
            
            <div v-if="hasVideoError" class="error-overlay">
              <div class="error-content">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="#ef4444" stroke-width="2"/>
                  <path d="M15 9l-6 6M9 9l6 6" stroke="#ef4444" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h4>Помилка завантаження відео</h4>
                <p>Не вдалося завантажити навчальне відео</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Fallback if no video -->
        <div v-else class="no-content">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
            <path d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" stroke="#6b7280" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <h4>Відео недоступне</h4>
          <p>Навчальне відео для цього розділу в розробці</p>
          <button v-if="item && item.link" @click="openNotionLink" class="documentation-button">
            📚 Переглянути документацію
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnboardingModal',

  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },

  data () {
    return {
      isVideoLoading: true,
      hasVideoError: false
    }
  },

  computed: {
    lang () {
      const language = this.$store.getters['account/lang']
      return language === 'us' ? 'en' : language
    },
    youtubeUrl () {
      if (!this.item.video_link) return ''

      const url = this.item.video_link

      if (url.includes('embed')) {
        return url.includes('?') ? `${url}&rel=0` : `${url}?rel=0`
      }

      const listMatch = url.match(/[?&]list=([a-zA-Z0-9_-]+)/)
      const indexMatch = url.match(/[?&]index=(\d+)/)

      const videoId = this.extractVideoId(url)
      const listId = listMatch ? listMatch[1] : null
      const index = indexMatch ? indexMatch[1] : null

      if (videoId && listId && index) {
        return `https://www.youtube.com/embed/${videoId}?list=${listId}&index=${index}&rel=0&autoplay=1`
      }

      if (listId) {
        return `https://www.youtube.com/embed/videoseries?list=${listId}&rel=0&autoplay=1`
      }

      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1`
      }

      return url
    }

  },

  methods: {
    handleOverlayClick () {
      this.$emit('close')
    },
    /* eslint-disable */
    extractVideoId (url) {
      const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
      const match = url.match(regex)
      return match ? match[1] : null
    },
    /* eslint-enable */
    openNotionLink () {
      this.$emit('open-notion')
    },
    handleVideoLoad () {
      this.isVideoLoading = false
      this.hasVideoError = false
    },
    handleVideoError () {
      this.isVideoLoading = false
      this.hasVideoError = true
    },
    handleKeydown (event) {
      if (event.key === 'Escape') {
        this.$emit('close')
      }
    }
  },

  mounted () {
    document.addEventListener('keydown', this.handleKeydown)
  },

  beforeDestroy () {
    document.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 2rem;
}

.modal-container {
  background: white;
  border-radius: 1.2rem;
  width: 100%;
  max-width: 140rem;
  height: 80vh;
  max-height: 70rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.6rem 2rem;
  padding-right: 1rem;
  border-bottom: 0.1rem solid #e5e7eb;
  background: #f9fafb;
  flex-shrink: 0;

  h3 {
    margin: 0;
    font-size: 1.6rem;
    font-weight: 600;
    color: #1f2937;
  }
}

.header-actions {
  display: flex;
  gap: 1.2rem;
  align-items: center;
}

.notion-button {
  background: #1da643;
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 0.6rem;
  font-size: 1.3rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  
  svg {
    margin-top: -0.2rem;
  }

  &:hover {
    background: #5ebe40;
  }

  &:focus {
    outline: 0.2rem solid #1da643;
    outline-offset: 0.2rem;
  }
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.6rem;
  border-radius: 1rem;
  color: #000;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eee;
  width: 3.6rem;
  height: 3.6rem;
  svg {
    width: 2rem;
  }

  &:hover {
    background-color: #f6dcdc;
    color: #000;
  }

  &:focus {
    outline: 0.2rem solid #3b82f6;
    outline-offset: 0.2rem;
  }
}

.modal-body {
  flex: 1;
  overflow: hidden;
  position: relative;
}

.video-container {
  width: 100%;
  height: 100%;
  position: relative;
  background: #000;
}

.video-wrapper {
  width: 100%;
  height: 100%;
  position: relative;

  iframe {
    display: block;
    border: none;
  }
}

.loading-overlay,
.error-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  color: white;
}

.loading-spinner {
  width: 4rem;
  height: 4rem;
  border: 0.4rem solid rgba(255, 255, 255, 0.3);
  border-top: 0.4rem solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1.6rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-overlay p {
  font-size: 1.4rem;
  margin: 0;
}

.error-content {
  text-align: center;
  max-width: 30rem;

  h4 {
    margin: 1.6rem 0 0.8rem 0;
    font-size: 1.8rem;
  }

  p {
    margin: 0 0 2.4rem 0;
    font-size: 1.4rem;
    opacity: 0.9;
  }
}

.retry-button, .documentation-button {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 0.8rem;
  font-size: 1.4rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #2563eb;
  }

  &:focus {
    outline: 0.2rem solid #3b82f6;
    outline-offset: 0.2rem;
  }
}

.documentation-button {
  background: #1da643;
  
  &:hover {
    background: #5ebe40;
  }
}

.no-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 4rem;
  color: #6b7280;
  background: #f9fafb;

  h4 {
    margin: 1.6rem 0 0.8rem 0;
    color: #374151;
    font-size: 1.8rem;
  }

  p {
    margin: 0 0 2.4rem 0;
    font-size: 1.4rem;
  }
}

// Респонсивність
@media (max-width: 768px) {
  .modal-overlay {
    padding: 1rem;
  }

  .modal-container {
    height: 90vh;
    max-height: none;
  }

  .modal-header {
    padding: 1.2rem 1.6rem;

    h3 {
      font-size: 1.4rem;
    }
  }

  .header-actions {
    gap: 0.8rem;
  }

  .notion-button {
    padding: 0.4rem 0.8rem;
    font-size: 1.2rem;
  }
}
</style>